// TODO: use Loader of library after upgrade to the version that can pass style from the outside https://cashdash.atlassian.net/browse/ARCEXP-265
// import { Loader } from '@rapyd/react-ui-library';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import PuffLoader from 'react-spinners/PuffLoader';

interface IProps {
  isInner?: boolean;
  size?: number;
  className?: string;
  isOverlay?: boolean;
}

const Spinner = ({ isInner = false, size, className, isOverlay }: IProps) => {
  const cssOverride = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)'
  } as CSSProperties;
  return !isInner ? (
    <GlobalSpinnerWrapper
      data-testid="page-loader"
      isOverlay={isOverlay}
      className={className}
    >
      <HCPLoader loaderSize={size || 100} cssOverride={cssOverride} />
    </GlobalSpinnerWrapper>
  ) : (
    <InnerSpinnerWrapper data-testid="inner-loader" className={className}>
      <StyledInnerLoaderWrapper>
        <HCPLoader loaderSize={size || 40} cssOverride={cssOverride} />
      </StyledInnerLoaderWrapper>
    </InnerSpinnerWrapper>
  );
};

const GlobalSpinnerWrapper = styled.div<{ isOverlay?: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
  opacity: ${({ isOverlay }) => (isOverlay ? 0.6 : 1)};
  z-index: 130;
`;

const InnerSpinnerWrapper = styled.div`
  display: flex;
  z-index: 2;
`;

const StyledInnerLoaderWrapper = styled.div`
  margin: auto;
  position: relative;
  display: flex;
`;

export default Spinner;

interface IHCPLoaderProps {
  loaderSize?: number;
  loaderSpeed?: number;
  cssOverride?: CSSProperties;
}

const DEFAULT_LOADER_SIZE = 60;
const DEFAULT_LOADER_SPEED = 1;

const HCPLoader = ({ loaderSize, loaderSpeed, cssOverride }: IHCPLoaderProps) => {
  return (
    <PuffLoader
      size={loaderSize || DEFAULT_LOADER_SIZE}
      speedMultiplier={loaderSpeed || DEFAULT_LOADER_SPEED}
      cssOverride={cssOverride}
    />
  );
};
